// This file was generated by "make codegen/iam". DO NOT EDIT.
import { allowedActions } from "./allowedActions";

export const roleRegistrationTokenCreator = {
  id: "registration-token-creator",
  mrn: "//iam.api.mondoo.app/roles/registration-token-creator",
  title: "Registration Token Creator",
  allowedActions,
} as const;

export type RoleRegistrationTokenCreator = typeof roleRegistrationTokenCreator;
